<template>
  <div>
    <div  :class="{'mx-9':$vuetify.breakpoint.lgAndUp, 'mx-0': $vuetify.breakpoint.mdAndDown}"> 
    <v-container>
      <v-toolbar flat color="#F0FFEA" height="30">
          <v-toolbar-title style="color:#62AE32" class="headline">Members</v-toolbar-title>
      </v-toolbar>
        <v-card class="mt-12">
            <v-card-title>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                color="#08911B"
                style="width:20%"
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-select outlined class="mt-6" label="Status" color="#08911B" :items="memberStatus" dense @change="MemberStatus($event)"></v-select>
        
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="Members"
            :items-per-page="10"
            :single-select="singleSelect"
            item-key="Id"
            :search="search"
            class="pa-5"
            no-data-text="No Members To Display"
            :loading="loader"
            >
                <!-- <template  v-slot:top>
                    <v-toolbar flat color="white">
                        <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            single-line
                            hide-details
                            color="#08911B"
                            style="width:20%"
                        ></v-text-field>
                        <v-spacer></v-spacer>
                        <v-select class="mt-3" label="Status" color="#08911B" :items="memberStatus" dense @change="MemberStatus($event)"></v-select>
                    </v-toolbar>
                </template> -->
                <template v-slot:item.action="{ item }">
                  <v-btn icon @click="getName(item.Id)">
                    <v-icon color="#B45C5C">mdi-chevron-right</v-icon>
                  </v-btn>
                    <!-- <div @click="getName(item.Id)" style="color:#B45C5C; cursor: pointer;">
                        View more
                    </div> -->
                </template>

          </v-data-table>
      </v-card>
    </v-container>
    </div>
  </div>
</template>

<script>
export default {
  name: 'community',
  components: {
  },
  data: () => ({
    search:'',
     headers: [
      {
      text: 'Name',
      align: 'left',
      sortable: false,
      value: 'name',
      class:'font-weight-black'
      },
      {text: 'Username', value:'username'},
      {text: 'Community', value:'community_name'},
      {text:'Email', value:'email', sortable: false},
      {text:'PhoneNumber', value:'phonenumber', sortable: false},
      { text: '', value: 'action', sortable: false },
    ],
    memberStatus:["Verified", "Not Verified", "All"],
    loader:false
  }),
  computed:{
    Members(){
      return this.$store.state.community.members
    },
  },
  methods:{ 
    getName(id){
        this.$store.dispatch("MembersById",id)
        .then((success)=>{
        this.$router.push(`/community/members/${success.member[0].username}`)
        })
        .catch(()=>{
        }) 
    },
    MemberStatus(event){
      this.loader=true
        if(event==="All"){
            this.$store.dispatch("getMembers")
            .then(()=>{
              this.loader=false
            })
            .catch(()=>{ 
              this.loader=false
            });

        }else{
            this.$store.dispatch("getMembersFilter", {"status":event})
            .then(()=>{
            this.loader=false
            })
            .catch(()=>{
            this.loader=false
            });

      }
    },
  },
  created(){
    this.$store.dispatch("getMembers")
    this.loader=true
    .then(()=>{
      this.loader=false
    })
    .catch(()=>{
      this.loader=false
    });
  }
};
</script>
<style  scoped>
  #item{
    background-color:#F0FFEA !important;
    min-height:100vh;
  }
</style>